import { useEffect, useState, useRef, useContext } from 'react';
import { Box, useTheme, Button, TextField } from "@mui/material";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@material-ui/core"
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../theme";
import SaveIcon from '@mui/icons-material/Save';
import Header from "./Header";
import useAxiosPrivate from "../hooks/useAxiosPrivate"
import saveSettings from './managers/saveSettings';
import { useNavigate, useLocation } from 'react-router-dom';
import { SettingsBarContext } from '../context/SettingsBarContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import handleError from "../hooks/handleError";
import { Formik } from "formik";
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';




export default function TwoFactorAuthPopup(props) {
    const { answerURL, connected_account, openTwoAuth, setOpenTwoAuth } = props;
    const axiosPrivate = useAxiosPrivate();
    const userRef = useRef();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [code, setCode] = useState();

    const initialValues = {
        code: ""
    }

    const handleBlur = (event) => {

    };

    const handleChange = (event) => {
        setCode(event.target.value);
    }

    const handleFormSubmit = async (answerURL) => {
        console.log(answerURL)
        try {
            const response = await axiosPrivate.post(answerURL,
                JSON.stringify({
                    code: code,
                }),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true,
                    timeout: 20000 // 20s timeout
                }
            );

        } catch (err) {
            handleError(err);
        }
        setOpenTwoAuth(false)
    };



    return (
        <Dialog open={openTwoAuth} onClose={() => setOpenTwoAuth(false)}>
            <DialogTitle sx={{ fontFamily: 'Source Sans Pro' }}>Two-Factor Authentication Needed</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Enter your {connected_account} 2FA code here
                </DialogContentText>

                <TextField
                    autoFocus
                    margin="dense"
                    id="code"
                    label="Code"
                    type="password"
                    fullWidth
                    variant="standard"
                    onChange={(event) => handleChange(event)}
                />
            </DialogContent >
            <DialogActions>
                <Button type="submit" onClick={() => handleFormSubmit(answerURL)}
                    sx={{
                        backgroundColor: colors.greenAccent[500],
                        color: "#ffffff",
                        '&:hover': {
                            backgroundColor: colors.greenAccent[300],
                            color: "#ffffff",
                        },
                        fontSize: "14px",
                        fontWeight: "bold",
                        padding: "10px 20px",
                    }}>
                    Submit
                </Button>
            </DialogActions>
        </Dialog >
    )
};